import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
console.log("Welcome to this ReactJS application crafted by Nizar Ben Younes with specialized modularization of my innovation.");
console.log("Bienvenue dans cette application ReactJS crée par Nizar Ben Younes, élaborée avec une spécialisation modulaire de mon innovation.")
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Welcome to this ReactJS application crafted by Nizar Ben Younes with specialized modularization of my innovation.

reportWebVitals();
